<form [formGroup]="supportForm" class="dashboard-tile" style="width:600px; height:600px; box-sizing:content-box;" (ngSubmit)="send()">
  <div class="tile-header">
    <div class="tile-header-title">Contact Us</div>
  </div>
  <div class="tile-content">
    <div class="formFieldList" style="height: calc(100% - 41px);">
      <div style="padding-top: 20px; padding-bottom: 30px;">Please describe your issue and a customer success specialist will contact you.</div>
      <mat-form-field>
        <input matInput placeholder="Name" formControlName="name" required>
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Email" formControlName="email" required>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Help Topic" formControlName="helpTopic" required>
          <mat-option *ngFor="let htopic of helpTopics" [value]="htopic">{{htopic}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <textarea style="height:200px;" matInput placeholder="Description" formControlName="description" required></textarea>
      </mat-form-field>
    </div>
    <div class="tile-footer">
      <button mat-button color="primary" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" type="submit">Submit</button>
    </div>
  </div>
</form>
